import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/routes';
import { AuthProvider } from '@/features/auth/AdminAuthContext';
import { DesignProvider } from '@/features/design/DesignProvider';
import '@/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 1 },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <DesignProvider>
          <RouterProvider router={router} />
        </DesignProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);